import { render, staticRenderFns } from "./ConfigForm.vue?vue&type=template&id=0a003c21"
import script from "./ConfigForm.vue?vue&type=script&lang=js"
export * from "./ConfigForm.vue?vue&type=script&lang=js"
import style0 from "./ConfigForm.vue?vue&type=style&index=0&id=0a003c21&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
